<template>
  <div class="doorpostdescribe">
    <div class="header">
      <div class="title">完善的智慧防疫设备</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="right">
        <img :src="EBEquipmentLogo" alt="" />
      </div>
      <div class="left">
        <div class="title">远程视频监控</div>
        <div class="text">
          主要用于社区、学校等远程监管人员的防疫以及密接、次密接、确诊等重点人员的监管防疫。具有精准测量体温、地理位置追踪、隔离区域越界等功能的智慧防疫设备
        </div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import EBEquipment1 from "../../../../assets/programme/EBEquipment1.png";
import EBEquipment2 from "../../../../assets/programme/EBEquipment2.png";
import EBEquipment3 from "../../../../assets/programme/EBEquipment3.png";

import EBEquipmentLogo from "../../../../assets/programme/EBEquipmentLogo.png";

export default {
  setup() {
    return reactive({
      EBEquipmentLogo: EBEquipmentLogo,
      list: [
        {
          id: 1,
          title: "远程无接触测温",
          logo: EBEquipment1,
        },
        {
          id: 2,
          title: "密接人员定位追踪",
          logo: EBEquipment2,
        },
        {
          id: 3,
          title: "居家隔离异常警报",
          logo: EBEquipment3,
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostdescribe {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}

.body .right img {
  width: 100%;
  margin-bottom: 16px;
}
.body .left .title {
  font-size: 14px;
  font-weight: 600;
}
.body .left .text {
  font-size: 12px;
  color: #495a6c;
  margin-top: 12px;
}
.body .left .list {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.body .left .list .item {
  text-align: center;
}
.body .left .list .item img {
  width: 36px;
}
.body .left .list .item div {
  font-size: 12px;
  margin-top: 8px;
  color: #495a6c;
}
</style>
